<script setup lang="ts">
interface DevicesInfoData {
  title: string
  description: string
  buttonLabel: string
  buttonLink: string
  imagePath: string
}

defineProps<{
  data?: DevicesInfoData
}>()
</script>

<template>
  <div v-if="data" class="flex flex-col items-center md:mt-12">
    <div>
      <img :src="`/services/${data.imagePath}`" class="h-[355px] w-[355px]" alt="" />
    </div>
    <div class="md:text-justify lg:text-left">
      <WPageHeader class="text-left">{{ data.title }} <br /></WPageHeader>
      <WParagraph> {{ data.description }} </WParagraph>
    </div>
  </div>
</template>
